/** @format */

import React from "react";

import { Link } from "react-router-dom";
import usePermissions from "../../components/permissions/permission";

const ItemReqFromBranch_nav = () => {
  const { hasPermission } = usePermissions();
  const BranchReqData = [
    {
      id: 1,
      header: "Create Branch Request",

      headerClasses: "text-black",
      linkTo: "/branch-req",
      permissionId: 1995,
    },
    {
      id: 2,
      header: "View Branch Requests",

      headerClasses: "text-black",
      linkTo: "/view-branch-req",
      permissionId: 1996,
    },
    {
      id: 3,
      header: "View Approved Branch Requests",

      headerClasses: "text-black",
      linkTo: "/view-approved-branch-req",
      permissionId: 1997,
    },
    {
      id: 4,
      header: "History Log of Recevied Branch Item Requests",

      headerClasses: "text-black",
      linkTo: "/view-item-approved-history-log-branch-req",
      permissionId: 1998,
    },
    {
      id: 5,
      header: "Branch Item Return Requests",

      headerClasses: "text-black",
      linkTo: "/branch-return-req",
      permissionId: 1998,
    },
    {
      id: 5,
      header: "Branch Item Return Released Requests",

      headerClasses: "text-black",
      linkTo:
        "/inventory/branch-item-return-released-list-req-view-branch-side",
      permissionId: 1998,
    },
  ];

  return (
    <div className="bg-background overflow-y-auto h-screen">
      <p className="text-[25px] font-sans ml-6 mt-6 font-bold text-[#797C80] ">
        Branch Requests
      </p>

      {/* Cards with "Click Here" buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-12 mt-[10%] mx-6 ">
        {BranchReqData.map((card) =>
          hasPermission(card.permissionId) ? (
            <Link key={card.id} to={card.linkTo}>
              <div
                key={card.id}
                className="bg-white rounded-[32px] p-4 shadow-md flex flex-col justify-between"
              >
                <div>
                  {/* Conditional rendering based on header words */}
                  <h2 className="text-[20px] font-semibold mb-1 w-100px">
                    {card.header}
                  </h2>
                </div>
                <div className="flex justify-between items-center">
                  <button className="bg-primary w-[30%] mt-2 text-white font-bold py-2 px-4 rounded-[22px]">
                    Click Here
                  </button>

                  <div className="bg-primary w-[13px] h-[37px] rounded-xl"></div>
                </div>
              </div>
            </Link>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ItemReqFromBranch_nav;
